import { render, staticRenderFns } from "./RipsHospitalizacion.vue?vue&type=template&id=72dd3910"
import script from "./RipsHospitalizacion.vue?vue&type=script&lang=js"
export * from "./RipsHospitalizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports